import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useProfile } from "../context/ProfileContext";
import { Sparkles } from "lucide-react";

export default function OnboardingModal() {
  const { profile, update, touch } = useProfile();
  const location = useLocation();
  const [name, setName] = useState(profile.name || "");
  const [level, setLevel] = useState(profile.level || "school");
  const [language, setLanguage] = useState(profile.language || "english");

  if (profile.onboarded) return null;
  // Don't block Bharat Quest or XR — they have their own flows
  if (location.pathname.startsWith("/bharat-quest") || location.pathname.startsWith("/xr")) return null;

  const submit = (e) => {
    e.preventDefault();
    update({ name: name.trim() || "Friend", level, language, onboarded: true });
    touch();
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40 px-4" data-testid="onboarding-modal">
      <div className="bg-[#F4F1EA] border border-[#DCD7CE] rounded-2xl max-w-md w-full p-7 fadeIn">
        <div className="w-11 h-11 rounded-full bg-[#FBE7DF] grid place-items-center text-[#E07A5F] mb-4">
          <Sparkles size={20} />
        </div>
        <h2 className="font-heading text-2xl font-bold text-[#1A1A1A]">Hello! Let's set you up.</h2>
        <p className="text-sm text-[#4A4A4A] mt-2">A few quick details so I can personalise stories, quizzes &amp; paths.</p>
        <form className="mt-5 space-y-4" onSubmit={submit}>
          <div>
            <div className="text-[11px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold mb-1">Your name</div>
            <input
              className="input-field"
              placeholder="e.g. Anjali"
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="onboard-name"
              autoFocus
            />
          </div>
          <div>
            <div className="text-[11px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold mb-1">I am a…</div>
            <div className="flex gap-2 flex-wrap">
              {[
                { v: "school", l: "School (4–10)" },
                { v: "college", l: "College / 11–UG" },
                { v: "youth", l: "Youth & Careers" },
              ].map((o) => (
                <button
                  key={o.v}
                  type="button"
                  onClick={() => setLevel(o.v)}
                  data-testid={`onboard-level-${o.v}`}
                  className={`px-3 py-1.5 rounded-full text-xs font-semibold ${
                    level === o.v ? "bg-[#3A5A40] text-white" : "bg-white border border-[#DCD7CE]"
                  }`}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-[11px] tracking-[0.18em] uppercase text-[#3A5A40] font-semibold mb-1">Language</div>
            <div className="flex gap-2 flex-wrap">
              {[
                { v: "english", l: "English" },
                { v: "hindi", l: "Hindi" },
                { v: "spanish", l: "Spanish" },
              ].map((o) => (
                <button
                  key={o.v}
                  type="button"
                  onClick={() => setLanguage(o.v)}
                  data-testid={`onboard-lang-${o.v}`}
                  className={`px-3 py-1.5 rounded-full text-xs font-semibold ${
                    language === o.v ? "bg-[#E07A5F] text-white" : "bg-white border border-[#DCD7CE]"
                  }`}
                >
                  {o.l}
                </button>
              ))}
            </div>
          </div>
          <button type="submit" className="btn-primary w-full" data-testid="onboard-submit">
            Start exploring
          </button>
        </form>
      </div>
    </div>
  );
}
